/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface ComponentConfigsSpec { 
    configs?: object;
    vcds_service_type: VcdsServiceTypeEnum;
}
export namespace ComponentConfigsSpec {
}


